import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui";


interface ExpiredPlanModalProps {
  show: boolean;
  onClose: () => void;
  onResubscribe?: () => void;
}

const ExpiredPlanModal: React.FC<ExpiredPlanModalProps> = ({
  show,
  onClose,
  onResubscribe,
}) => {
  const navigate = useNavigate();

  if (!show) return null;

  const handleButtonClick = () => {
    if (onResubscribe) {
      onResubscribe();
    } else {
      navigate("/billings");
      onClose();
    }
  };

  

  return (
    <div className="modal-overlay fixed inset-0 z-[10001] flex items-center justify-center bg-black/40 px-4">
      <div className="modal-container w-full max-w-[420px] rounded-[12px] border border-light-grey bg-white p-6 shadow-lg">
        <h2 className="text-center text-[24px] font-semibold leading-[1.2] text-dark-black">
          Your Plan Has Expired
        </h2>
        <p className="mt-3 text-center text-sm leading-[1.5] text-dark-grey">
          It looks like your trial or subscription has ended. Re-subscribe to
          regain access to premium features.
        </p>
        <p className="mt-3 text-center text-xs leading-[1.4] text-dark-grey">
          Contact support via chat if you need help with billing.
        </p>
        <div className="mt-5 flex items-center justify-center gap-3">
          <Button variant="primary" size="sm" onClick={handleButtonClick}>
            Re-subscribe
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="border-light-grey"
            onClick={() => {
              navigate("/billings");
              onClose();
            }}
          >
            Go to Billing
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExpiredPlanModal;